import { PublicTenant } from "./PublicTenant";

export class Tenant extends PublicTenant {
    id: number;
    qsId: string;
    ogkNumber: string;
    ggnNumber: string;
    skalNumber: string;
}
